// Emergency utility to clear all stuck sync records
import { syncTracker } from '../sync-tracker';

/**
 * Emergency function to clear all stuck sync records
 * This will stop all the sync errors immediately
 */
export function emergencyClearSyncQueue() {
  try {
    // Clear all changes from sync tracker
    syncTracker.clearChanges();
    
    // Also clear failed consultations specifically
    const clearedConsultations = syncTracker.clearFailedConsultations();
    
    console.log('🚨 EMERGENCY CLEAR COMPLETE:');
    console.log(`✅ Cleared all sync records`);
    console.log(`✅ Cleared ${clearedConsultations} failed consultation records`);
    console.log('🔄 Sync errors should stop now');
    
    return true;
  } catch (error) {
    console.error('❌ Emergency clear failed:', error);
    return false;
  }
}

// Make it available globally
if (typeof window !== 'undefined') {
  (window as any).emergencyClear = emergencyClearSyncQueue;
  console.log('🚨 Emergency clear available: Run emergencyClear() in console');
}
